import React, { useState, useEffect } from "react";
import { Pie } from "@ant-design/plots";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { dashboardApplication } from "../../../helpers/helper";
import { listMonth } from "../../../helpers/common";

const { Option } = Select;

function DashboardApplication() {
  const { t } = useTranslation();
  document.title = t("menuTotal");
  const date = new Date();
  const [data, setData] = useState([]);
  const [valueMonth, setValueMonth] = useState(
    `${date.getMonth() + 1},${date.getFullYear()}`
  );
  const handleChange = (value) => {
    setValueMonth(value);
  };
  const listDataMonth = listMonth(date, 9);

  useEffect(() => {
    try {
      const dateTime = valueMonth.split(",");
      const fecthData = async () => {
        let time = {
          month: parseInt(dateTime[0]),
          year: parseInt(dateTime[1]),
        };
        const dataRes = await dashboardApplication(time);

        setData(dataRes);
      };
      fecthData();
    } catch (error) {
      console.log(error);
    }
  }, [valueMonth]);

  const config = {
    appendPadding: 10,
    data,
    angleField: "value",
    colorField: "type",
    radius: 0.9,
    label: {
      type: "inner",
      offset: "-30%",
      content: ({ percent }) => `${(percent * 100).toFixed(0)}%`,
      style: {
        fontSize: 14,
        textAlign: "center",
      },
    },
    interactions: [
      {
        type: "element-active",
      },
    ],
  };

  return (
    <div style={{ padding: "20px" }}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          <div style={{ fontSize: "35px", paddingBottom: "5px" }}>
            {t("pieChart")}
          </div>
          <div>{`${t("applyChartUser")} ${valueMonth.split(",")[0]}/${
            valueMonth.split(",")[1]
          }`}</div>
        </div>
        <div style={{ padding: "20px" }}>
          <Select
            showSearch
            options={listDataMonth}
            value={valueMonth}
            onChange={handleChange}
            style={{ width: "200px" }}
          >
            {listDataMonth.length > 0 &&
              listDataMonth.map((key, item) => {
                return (
                  <Option key={key} value={item.valueOf}>
                    {item.label}
                  </Option>
                );
              })}
          </Select>
        </div>
      </div>
      <Pie {...config} style={{ padding: "20px" }} />
    </div>
  );
}

export default DashboardApplication;
